// extracted by mini-css-extract-plugin
export default {"container":"cq-z","heading":"dq-z","text":"eq-z","info":"fq-z","link":"gq-z","fullMaxWidth":"hq-z"};